export default {
  index: [
    {
      path: '/qccmanager',
      component: resolve => require(['./qccmanagerIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qccmanager/_router.js